import React, { useRef } from 'react';

import styled from 'styled-components';

import ShopDataModalAccommodations from './accommodations/ShopDataModalAccommodations';
import { SHOP_DATA_TABS_GENERAL_KEY } from './constants';
import ShopDataModalContractBenefits from './contractBenefits/ShopDataModalContractBenefits';
import ShopDataModalDocuments from './documents/ShopDataModalDocuments';
import ShopDataModalFees from './fees/ShopDataModalFees';
import { SHOP_DATA_MENU_STEPS } from './menus';
import ShopDataModalOccupancies from './occupancies/ShopDataModalOccupancies';
import { useShopDataModalContext } from './ShopDataModalContext';
import ShopDataModalFooter from './ShopDataModalFooter';
import ShopDataModalShopNotes from './shopNotes/ShopDataModalShopNotes';
import Loader from '../lib/Loader';

const Container = styled.div`
  display: flex;
  flex-grow: 1;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  overflow-x: auto;
`;

const Content = styled.div`
  display: flex;
  flex-grow: 1;
  overflow-y: auto;
  flex-direction: column;
`;

const ShopDataModalContent = () => {
  const { loading, currentData, currentTab, currentStep } = useShopDataModalContext();
  const actionsRef = useRef<HTMLDivElement>(null);

  if (!currentData || loading) return <Loader active />;

  return (
    <Container>
      <Content className={'mini-scroll'}>
        {currentTab === SHOP_DATA_TABS_GENERAL_KEY && (
          <>
            {currentStep === SHOP_DATA_MENU_STEPS.DOCUMENTS && <ShopDataModalDocuments />}
            {currentStep === SHOP_DATA_MENU_STEPS.OCCUPANCIES && <ShopDataModalOccupancies />}
            {currentStep === SHOP_DATA_MENU_STEPS.SHOP_NOTES && <ShopDataModalShopNotes />}
            {<ShopDataModalContractBenefits step={currentStep} />}
          </>
        )}
        {currentTab !== SHOP_DATA_TABS_GENERAL_KEY && (
          <>
            {currentStep === SHOP_DATA_MENU_STEPS.FEES && <ShopDataModalFees />}
            {currentStep === SHOP_DATA_MENU_STEPS.ACCOMMODATIONS && (
              <ShopDataModalAccommodations actionsRef={actionsRef.current} />
            )}
          </>
        )}
      </Content>
      <div>
        <div ref={actionsRef} />
        <ShopDataModalFooter />
      </div>
    </Container>
  );
};

export default ShopDataModalContent;
